import type { HttpAgent } from '@dfinity/agent';
import { getCanisterId } from '../config/canisterIds';

// Limited Edition canister service
export async function createLimitedEditionActor(agent: HttpAgent) {
  const canisterId = getCanisterId('limited_edition');
  if (!canisterId) {
    throw new Error('Limited Edition canister ID not configured. Set VITE_LIMITED_EDITION_CANISTER_ID in .env.production');
  }

  // NOTE: Frontend declarations for limited_edition are not present yet.
  // This service returns the canister id so the UI can still render something,
  // and can be upgraded later to a typed Actor once `dfx generate` produces declarations.
  return { canisterId, agent };
}

export async function getAllLimitedEditionNFTs(agent: HttpAgent) {
  try {
    const { canisterId } = await createLimitedEditionActor(agent);
    // Placeholder until we have declarations/IDL for candid encoding.
    return [
      {
        status: 'pending',
        canister_id: canisterId,
        discount_code: '',
        metadata: { name: 'Limited Edition (pending declarations)' },
        nft_number: 0,
      },
    ];
  } catch (err) {
    console.error('Failed to fetch limited edition NFTs:', err);
    throw err;
  }
}






